/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconMiscLogoGreyscale = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 92 40"
  >
    <g fill="currentColor">
      <path d="M9.3 22.6l3.7-7c.2-.4.3-.6.8-.6h4c.2 0 .3.1.4.2 0 .1.1.1.1.2s0 .2-.1.2l-5.8 10.6 6.1 11.1c0 .1.1.2.1.2 0 .1 0 .2-.1.2-.1.1-.2.2-.4.2h-4c-.5 0-.6-.3-.8-.6l-4.1-7.5-4.1 7.5c-.2.4-.3.6-.8.6h-4c-.2 0-.3-.1-.4-.2-.1-.1-.1-.3 0-.5L6 26.1.4 15.7c-.1-.2-.1-.3 0-.5.1-.1.2-.2.4-.2h4c.5 0 .6.3.8.6l3.7 7zM40.2 28.8V15.6c0-.3.2-.6.6-.6H44c.3 0 .6.2.6.6v21.9c0 .3-.2.6-.6.6h-3.3c-.4 0-.7-.3-.8-.6l-6.8-13.2v13.2c0 .3-.2.6-.6.6h-3.2c-.3 0-.6-.2-.6-.6V15.6c0-.3.3-.6.6-.6h3.3c.5 0 .6.3.8.6l6.8 13.2zM20.8 37.5V15.6c0-.3.2-.6.6-.6h3.2c.3 0 .6.2.6.6v21.9c0 .3-.2.6-.6.6h-3.2c-.4 0-.6-.3-.6-.6zM57.6 18.7c-1.7 0-3.1.4-4.2 1.9-1 1.4-1.6 3.2-1.6 5.8 0 2.5.1 4.5 1 5.8.8 1.3 2.2 2.2 3.9 2.2 1.9 0 3.3-.5 3.3-.5V29h-3.3c-.3 0-.6-.3-.6-.6v-2.8c0-.3.2-.6.6-.6h7.1c.3 0 .6.3.6.6v11.1c-.2.1-3.7 1.8-7.9 1.8-3.5 0-5.5-1.3-6.9-3.2-1.6-2.1-2.2-5.6-2.2-8.8 0-2.3.3-4.4 1.1-6.2.8-1.9 2.2-3.4 3.6-4.2 1.6-.9 3.5-1.3 5.4-1.3h.5c2.9 0 4.6.7 5.2 1 .5.2.6.4.6.7v2.7c0 .2-.1.3-.2.4-.1.1-.3.1-.4.1-1.1-.4-2.8-.9-5.1-.9h-.5z" />
      <path
        d="M87.8 2.3c-.5 0-.8.3-1 .7 0 0-7.7 13.7-8 14.1l5.1 9.3c.2.3.5.7 1 .7h3.6c.2 0 .4-.1.5-.2.1-.2.1-.4 0-.6l-5-9.2 7.9-14c.1-.2.1-.4 0-.6-.1-.1-.3-.2-.5-.2h-3.6z"
        opacity=".6"
      />
      <path d="M72.8 7.2c-.2 0-.4.1-.5.2-.1.2-.1.4 0 .6l2.4 4.2-3.7 6.7c-.1.2-.1.4 0 .6.1.1.3.2.5.2H75c.5 0 .8-.4 1-.7 0 0 3.7-6.6 3.9-6.8l-2.5-4.3c-.2-.3-.5-.7-1-.7h-3.6z" />
    </g>
  </svg>
);

IconMiscLogoGreyscale.displayName = 'IconMiscLogoGreyscale';

IconMiscLogoGreyscale.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconMiscLogoGreyscale);
IconMiscLogoGreyscale.displayName = 'IconMiscLogoGreyscale';
